export default __webpack_public_path__ + "static/media/buildings.e151691c.svg";